<template>
	<div id="content">
		<shutter-panel ref="shutterPanel" />
	</div>
</template>

<script type="text/javascript">
	import ShutterCongelation from "@/mixins/shutters-manager/Congelation.js"

	export default {
		name: 'StallionDoses',
		mixins: [ShutterCongelation],
		props: ['horse_id'],
		mounted() {
			this.setUpDosesListe(this.horse_id)
		},
	}
</script>